export const MUTATING_HTTP_METHODS = new Set([
  'post',
  'put',
  'patch',
  'delete',
]);
